import { render, staticRenderFns } from "./add-partners-zone-component.vue?vue&type=template&id=bacf8e36&scoped=true&"
import script from "./add-partners-zone-component.vue?vue&type=script&lang=js&"
export * from "./add-partners-zone-component.vue?vue&type=script&lang=js&"
import style0 from "./add-partners-zone-component.vue?vue&type=style&index=0&id=bacf8e36&scoped=true&lang=css&"
import style1 from "./add-partners-zone-component.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacf8e36",
  null
  
)

export default component.exports